import { defineComponent as _defineComponent } from 'vue'
import { BaseText, Link } from '@warrenbrasil/nebraska-web';
import type { RLPRegulationContentItem } from '@/modules/trade/services/rlp';

interface Props {
  item: RLPRegulationContentItem;
  inline?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RegulationItem',
  props: {
    item: null,
    inline: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,BaseText, Link }
}

})